import type { CalEvent } from "../../api/types";
import { MONTHS_SHORT, addDays, datePart, formatTime, longDateLabel, minutesOf, parts } from "../../lib/date";

/** "Na hora do evento", "10 minutos antes", "1 dia antes, às 09:00". */
export function reminderLabel(minutes: number, allDay: boolean): string {
  if (allDay) {
    const days = Math.round(minutes / 1440);
    return days === 0 ? "No dia, às 09:00" : `${days} ${days === 1 ? "dia" : "dias"} antes, às 09:00`;
  }
  if (minutes === 0) return "Na hora do evento";
  if (minutes % 10080 === 0) return `${minutes / 10080} ${minutes === 10080 ? "semana" : "semanas"} antes`;
  if (minutes % 1440 === 0) return `${minutes / 1440} ${minutes === 1440 ? "dia" : "dias"} antes`;
  if (minutes % 60 === 0) return `${minutes / 60} ${minutes === 60 ? "hora" : "horas"} antes`;
  return `${minutes} minutos antes`;
}

/** "quarta-feira, 30 de setembro · 18:00 até 19:00", or the all-day / multi-day forms. */
export function whenLabel(e: CalEvent): string {
  const startDay = datePart(e.start);
  if (e.allDay) {
    const last = addDays(e.end, -1);
    if (last === startDay) return longDateLabel(startDay);
    const a = parts(startDay);
    const b = parts(last);
    return `${a.d} de ${MONTHS_SHORT[a.m - 1]} – ${b.d} de ${MONTHS_SHORT[b.m - 1]} de ${b.y}`;
  }
  const endDay = datePart(e.end);
  const range = `${formatTime(minutesOf(e.start))} até ${formatTime(minutesOf(e.end))}`;
  if (endDay === startDay || (e.end.endsWith("T00:00") && endDay === addDays(startDay, 1))) return `${longDateLabel(startDay)} · ${range}`;
  return `${longDateLabel(startDay)}, ${formatTime(minutesOf(e.start))} até ${longDateLabel(endDay)}, ${formatTime(minutesOf(e.end))}`;
}
